import React from 'react';
import { VISIBILITY_STAGES, getRowActivity } from '../../core/shifts/shiftDailyBoard';
import { getShiftStartMs, getShiftEndMs } from '../../core/shifts/shiftLifecycle';
import PlannerDialog from './PlannerDialog';
import { resolveShiftTimeZone, zonedInputValue } from '../../core/shifts/shiftTimeZone';

export function shiftTime(shift) {
  const start = getShiftStartMs(shift), end = getShiftEndMs(shift);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return 'Time confirmation required';
  const timeZone = resolveShiftTimeZone(shift);
  if (!timeZone) return "Timezone unavailable";
  const format = value => new Date(value).toLocaleTimeString([], { timeZone, hour: 'numeric', minute: '2-digit' });
  return `${format(start)}–${format(end)}${zonedInputValue(start, timeZone).slice(0, 10) !== zonedInputValue(end, timeZone).slice(0, 10) ? ' (+1 day)' : ''}`;
}

export default function PlannerWorkerVisibility({ model, onSelect }) {
  const plannerStageLabel = (key, label) =>
    label;

  return <section className="daily-panel worker-visibility" aria-labelledby="worker-visibility-title">
    <div className="daily-panel-heading"><h2 id="worker-visibility-title">Live Worker Visibility</h2><span className="daily-muted">Selected date · shift counts</span></div>
    <div className="visibility-stages">{VISIBILITY_STAGES.map(([key, label]) => <button key={key} type="button" onClick={() => onSelect({ kind: 'stage', key, title: plannerStageLabel(key, label) })}>
      <span className={`visibility-marker stage-${key}`} aria-hidden="true" /><strong>{model.stages[key].length}</strong><span>{plannerStageLabel(key, label)}</span>
    </button>)}</div>
    {model.rows.some(r => r.stage === 'closed') && <button className="daily-text-button" onClick={() => onSelect({ kind: 'closed', title: 'Closed / exceptions' })}>Closed / exceptions: {model.rows.filter(r => r.stage === 'closed').length}</button>}
  </section>;
}

export function WorkerVisibilityDetail({ title, rows, workersByUid, facilityName, date, now, onClose, onOpenShift }) {
  const workerName = uid => {
    const worker = workersByUid.get(uid);
    return worker?.fullName || worker?.name || worker?.displayName || worker?.email || uid;
  };
  return <PlannerDialog title={title} onClose={onClose} wide>
    <p className="daily-muted">{facilityName} · {date} · {rows.length} shift{rows.length !== 1 ? 's' : ''}</p>
    {!rows.length ? <p className="daily-empty">No shifts in this view.</p> : <div className="daily-detail-list">{rows.map(row => {
      const { shift, summary, stage } = row;
      const uids = summary.assignedWorkerUid ? [summary.assignedWorkerUid] : stage === 'requested' ? shift.requestedWorkerUids || [] : shift.offeredWorkerUids || [];
      const activity = getRowActivity(row);
      return <article key={shift.id} className="daily-detail-row">
        <div><strong>{uids.length ? uids.map(workerName).join(', ') : 'Unassigned'}</strong><p>{row.role.replace(/_/g, ' ')} · {shiftTime(shift)}</p><small>{shift.unit || shift.unitName || facilityName} · Shift {shift.id}</small></div>
        <div><span className={`daily-badge ${row.exception?.tone || 'info'}`}>{stage === 'requested' ? 'Requested' : summary.operationalLabel}</span>
          <p>{activity.stageAt ? `${Math.max(0, Math.floor((now - activity.stageAt) / 60000))} min in state` : 'State timestamp unavailable'}</p>
          <small>{activity.latestAt ? `Last activity: ${new Date(activity.latestAt).toLocaleString()}` : 'Activity timestamp unavailable'}</small>
          {row.exception && <p>{row.exception.label}</p>}</div>
        <button className="daily-primary" onClick={() => onOpenShift(shift)}>{row.exception?.action || 'Open Shift 360'}</button>
      </article>;
    })}</div>}
  </PlannerDialog>;
}
